export default {
  "applications.menu.organization": "应用组",
  "applications.menu.organization.create": "创建分组",
  "applications.menu.start": "功能指南",
};
